// Independent page composition for User Experience & Interface Design.
const { h, PageFrame, section, split, context, deliverables, scenario, answer, scope, diagram } = require('../pageParts');
module.exports = function UserExperiencePage({ service }) {
  return h(PageFrame, { service, tone: 'split', hero: diagram(service, 'journey') },
    section('Design around the real workflow', split(context(service), scenario(service))),
    section('Make the next step practical', deliverables(service, 'timeline'), { theme: 'ai-wash', className: 'ai-narrow-section' }),
    section(null, split(answer(service), scope()))
  );
};
